<template>
  <div class="success_wrapper">
    <template v-if="getStatus">
      <img src="../../assets/new_success_ico.png" alt class="success_ico" />
      <div class="pay_price">
        <span class="price_unit">￥</span>{{ payableAmount }}
      </div>
      <div class="old_price">订单金额：￥{{ payableAmount }}</div>
      <div class="pay_info_box">
        <div class="pay_info_line">
          <span class="info_label grow">{{
            pay_name
          }}</span>
          <div class="info_text shrink">￥{{ payableAmount }}</div>
        </div>
        <!-- <div class="pay_info_line">
        <span class="info_label shrink">优惠金额</span>
        <div class="info_text price grow">
          -{{ orderInfo.preferential_amount }}
        </div>
      </div> -->
        <div class="pay_info_line">
          <span class="info_label shrink">付款方式</span>
          <div class="info_text grow">{{ payTypeArr[pay_type].name }}</div>
        </div>
      </div>
      <div class="success_btn" @click="click_success_btn">完成</div>
    </template>
  </div>
</template>

<script>
import { isAlipayClient, isWeChat } from "../../utils/config";
export default {
  data() {
    return {
      getStatus: false,
      payableAmount: "",
      pay_name: "",
      pay_type: "",
      payTypeArr: {
        H5_zz: {
          name: "至尊卡余额",
        },
        H5_tbj: {
          name: "通宝+",
        },
        H5_tb: {
          name: "通宝",
        },
        wx_jsapi: {
          name: "微信",
        },
        ali_jsapi: {
          name: "支付宝",
        },
      },
    };
  },
  created() {
    this.$toast.loading({
      message: "加载中",
      forbidClick: true,
      duration: 0,
    });
    let {
      payableAmount = "",
      pay_name = "",
      pay_type = "",
    } = this.$route.query;
    this.payableAmount = payableAmount;
    this.pay_name = pay_name;
    this.pay_type = pay_type;
    this.getStatus = true;
    this.$toast.clear();
  },
  methods: {
    //完成按钮点击事件
    click_success_btn() {
      if (isAlipayClient()) {
        this.closeAliPage();
      } else if (isWeChat()) {
        this.closeWxPage();
      }
    },
    closeAliPage() {
      document.addEventListener(
        "AlipayJSBridgeReady",
        function() {
          window.AlipayJSBridge.call("closeWebview");
        },
        false
      );
      window.AlipayJSBridge.call("closeWebview");
    },
    closeWxPage() {
      //安卓手机
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          window.WeixinJSBridge.call("closeWindow");
        },
        false
      );
      //ios手机
      window.WeixinJSBridge.call("closeWindow");
    },
  },
};
</script>

<style lang="less">
@import "./index";
</style>
